import Client, {VitrinClient} from '../client';
import {flattenObject} from '../helpers';
import {
  CloseTicketRequestBuilder,
  GetAllCategoriesRequestBuilder,
  GetAllTicketsCountRequestBuilder,
  GetAllTicketsRequestBuilder,
  GetTicketRequestBuilder,
  PostAllTicketsRequestBuilder,
} from '../helpical/categories';

import {
  GetAllOrdersRequestBuilder,
  GetOrdersCountRequestBuilder,
  UpdateOrderStatusRequestBuilder,
  CancelOrderRequestBuilder,
  GetOrderLogsBuilder,
  GetTPLOrderLogsBuilder,
  UpdateAllOrderRequestBuilder,
  GetAllOrdersReportRequestBuilder,
  AssignOrderRequestBuilder,
  CreatePostOrderRequestBuilder,
  UpdateAllOrderAssignRequestBuilder,
  GetAllOrdersPrintRequestBuilder,
  ChangeOrderDeliveryTypeRequestBuilder,
  AddOrderDimensionsRequestBuilder,
  DeletePostOrderRequestBuilder,
  UpdateOrderDeliveryTypeRequestBuilder,
  CreateOrderItemsRequestBuilder,
  UpdateOrderRequestBuilder,
  SetOrders3PLRequestBuilder,
  Cancel3PLItemRequestBuilder,
  Get3PLsRequestBuilder,
  GetOrder3PLsRequestBuilder,
  UpdateOrder3PLsRequestBuilder,
  CreateRequestOrder3PLsRequestBuilder,
  GetAllOrderItemsRequestBuilder,
  GetPostOrdersCountRequestBuilder,
  ResendOrdersRequestBuilder,
  GetIncomingOrdersRequestBuilder,
  GetVitrinOrdersRequestBuilder,
  GetPostOrdersRequestBuilder,
  SendDelayDeliveryOrderTimeSms,
  GetOrderTapinsRequestBuilder,
  GetOrderTapinsKetabRequestBuilder,
  GetOrderTapinsBarcodeRequestBuilder,
  GetSuggestedCourierAssignmentList,
  ValidateOrdersBeforeCreateTpl,
  CreateBatchTpl,
  Upload3PLRequestBuilder,
  UploadOrdersRequestBuilder,
  CreateOrderRequestBuilder,
  DeleteOrderItemRequestBuilder,
  GetOrderFileRequestBuilder,
  NewUpdateOrderRequestBuilder,
  GetOrder3PLStatusRequestBuilder,
  GetOrderPackageConfigsRequestBuilder,
} from '../orders/orders';

const token = localStorage.getItem('token') || '';

class OrdersRepository {
  getOrders = async (actions: any) => {
    const makeordersRequest = new GetAllOrdersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const makecountRequest = new GetOrdersCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeordersRequest);
    const count = await client.execute(makecountRequest);

    return {response, count};
  };
  getVitrinOrders = async (actions: any) => {
    const makeordersRequest = new GetVitrinOrdersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new VitrinClient(token);
    const response = await client.execute(makeordersRequest);

    return response;
  };
  getIncomingOrders = async (actions: any) => {
    const makeordersRequest = new GetIncomingOrdersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new VitrinClient(token);
    const response = await client.execute(makeordersRequest);

    return response;
  };
  getOrderTPLStatus = async (actions: any) => {
    const makeordersRequest = new GetOrder3PLStatusRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeordersRequest);

    return response;
  };
  getOrderPackageConfigById = async (actions: any) => {
    const makeRequest = new GetOrderPackageConfigsRequestBuilder()
    .id(actions.payload.id)
    .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getOrdersCount = async (actions: any) => {
    const makecountRequest = new GetOrdersCountRequestBuilder()
      .params(flattenObject({...actions, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makecountRequest);
    return {response};
  };

  getPostOrdersCount = async (actions: any) => {
    const makecountRequest = new GetPostOrdersCountRequestBuilder()
      .params(flattenObject({...actions, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makecountRequest);
    return {response};
  };

  createOrderItems = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeCreateOrderItemsReq = new CreateOrderItemsRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeCreateOrderItemsReq);
    return {response,callback};
  };

  getAllOrderItems = async (actions: any) => {
    const makeOrdersRequest = new GetAllOrderItemsRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeOrdersRequest);
    return response;
  };

  getOrdersPrint = async (actions: any) => {
    const makeOrdersRequest = new GetAllOrdersPrintRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeOrdersRequest);
    return response;
  };
  getOrderWithId = async (actions: any) => {
    const makeOrdersRequest = new GetAllOrdersRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeOrdersRequest);
    return response;
  };
  getVitrinOrderWithId = async (actions: any) => {
    const makeOrdersRequest = new GetAllOrdersRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new VitrinClient(token);
    const response = await client.execute(makeOrdersRequest);
    return response;
  };

  updateOrderStatus = async (actions: any) => {
    const {id, body, pagination, callback} = actions.payload;
    const makeUpdateOrderStatusRequest = new UpdateOrderStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateOrderStatusRequest);
    return {pagination, callback};
  };
  updateOrderDeliveryType = async (actions: any) => {
    const {id, body, pagination, callback} = actions.payload;
    const makeUpdateOrderStatusRequest =
      new UpdateOrderDeliveryTypeRequestBuilder().id(id).data(body).build();
    const client = new Client(token);
    await client.execute(makeUpdateOrderStatusRequest);
    return {pagination, callback};
  };
  addOrderDimensions = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateOrderStatusRequest = new AddOrderDimensionsRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateOrderStatusRequest);
    return callback;
  };
  createPostOrder = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    let makeUpdateOrderStatusRequest;
    if (body.send) {
      makeUpdateOrderStatusRequest = new CreatePostOrderRequestBuilder()
        .id(id)
        .send(id)
        .data(body)
        .build();
    } else {
      makeUpdateOrderStatusRequest = new CreatePostOrderRequestBuilder()
        .id(id)
        .data(body)
        .build();
    }
    const client = new Client(token);
    const response = await client.execute(makeUpdateOrderStatusRequest);
    return {response, callback};
  };
  getPostOrders = async (actions: any) => {
    const {id, callback, ...params} = actions.payload;
    let makePostOrdersRequest;
    if (id) {
      makePostOrdersRequest = new GetPostOrdersRequestBuilder().id(id).build();
    } else {
      makePostOrdersRequest = new GetPostOrdersRequestBuilder()
        .params(params)
        .build();
    }
    const client = new Client(token);
    const response = await client.execute(makePostOrdersRequest);
    return {response, callback};
  };

  cancelOrder = async (actions: any) => {
    const {id, body, pagination} = actions.payload;
    const makeCancelRequest = new CancelOrderRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeCancelRequest);
    return pagination;
  };
  sendDelayDeliveryOrderTimeSms = async (actions: any) => {
    const {id, body} = actions.payload;
    const makeCancelRequest = new SendDelayDeliveryOrderTimeSms()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeCancelRequest);
    return response;
  };
  deletePostOrder = async (actions: any) => {
    const {id, pagination, callback} = actions.payload;
    const makeCancelRequest = new DeletePostOrderRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    await client.execute(makeCancelRequest);
    return {pagination, callback};
  };
  getLogs = async (actions: any) => {
    const makeRequest = new GetOrderLogsBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getTPLLogs = async (actions: any) => {
    const makeRequest = new GetTPLOrderLogsBuilder()
      .params(flattenObject({...actions.payload}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getAllOrdersReport = async (actions: any) => {
    const makeOrdersRequest = new GetAllOrdersReportRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeOrdersRequest);
    return response;
  };
  getAllOrders = async (actions: any) => {
    const makeOrdersRequest = new GetAllOrdersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeOrdersRequest);

    return response;
  };
  getHelpical = async (actions: any) => {
    const makeCatRequest = new GetAllCategoriesRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeCatRequest);

    return response;
  };
  getHelpicalTickets = async (actions: any) => {
    const makeTicketRequest = new GetAllTicketsRequestBuilder()
      .params(flattenObject({...actions}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeTicketRequest);

    return response;
  };
  getHelpicalTicket = async (actions: any) => {
    const makeTicketRequest = new GetTicketRequestBuilder()
      .id(actions.id)
      .build();

    const client = new Client(token);
    const response = await client.execute(makeTicketRequest);

    return response;
  };
  closeHelpicalTicket = async (actions: any) => {
    const makeTicketRequest = new CloseTicketRequestBuilder()
      .id(actions.id)
      .build();

    const client = new Client(token);
    const response = await client.execute(makeTicketRequest);

    return response;
  };
  postHelpicalTickets = async (actions: any) => {
    const makeTicketRequest = new PostAllTicketsRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeTicketRequest);

    return response;
  };
  getHelpicalTicketsCount = async (actions: any) => {
    const makeTicketCountRequest = new GetAllTicketsCountRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeTicketCountRequest);
    return {response};
  };
  updateAllOrderStatus = async (actions: any) => {
    const {ids, status, description, pagination} = actions.payload;
    const makeUpdateAllOrderStatusRequest = new UpdateAllOrderRequestBuilder()

      .data({ids, status, description})
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateAllOrderStatusRequest);
    return pagination;
  };
  updateAllOrderAssign = async (actions: any) => {
    const {ids, operatorId, description, pagination, callback} =
      actions.payload;
    const makeUpdateAllOrderStatusRequest =
      new UpdateAllOrderAssignRequestBuilder()
        .id(operatorId)
        .data({ids})
        .build();
    const client = new Client(token);
    await client.execute(makeUpdateAllOrderStatusRequest);
    return {description, pagination, callback};
  };
  assignOrder = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeAssignOrderRequest = new AssignOrderRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeAssignOrderRequest);
    return callback;
  };
  updateOrder = async (actions: any) => {
    const {body, callback} = actions.payload;
    const updateOrderReq = new UpdateOrderRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(updateOrderReq);
    return callback;
  };
  newUpdateOrder = async (actions: any) => {
    const {body, callback} = actions.payload;
    const updateOrderReq = new NewUpdateOrderRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(updateOrderReq);
    return callback;
  };
  createOrder = async (actions: any) => {
    const {body, callback} = actions.payload;
    const createOrderReq = new CreateOrderRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(createOrderReq);
    return callback;
  };
  changeOrderDeliveryType = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeChangeOrderDeliveryTypeRequest =
      new ChangeOrderDeliveryTypeRequestBuilder().id(id).data(body).build();
    const client = new Client(token);
    await client.execute(makeChangeOrderDeliveryTypeRequest);
    return callback;
  };
  getOrderFile = async (actions: any) => {
    const {id, params} = actions.payload;
    const makeOrdersReq = new GetOrderFileRequestBuilder()
      .id(id)
      .params(params)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeOrdersReq);
    return response;
  };
  deleteOrderItem = async (actions: any) => {
    const {id} = actions.payload;
    const makeRemoveItemReq = new DeleteOrderItemRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRemoveItemReq);
    return response;
  };
  setOrders3PL = async (actions: any) => {
    const {body, callback} = actions.payload;
    const makeSetOrders3PLReq = new SetOrders3PLRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return {response, callback};
  };
  get3PLs = async (actions: any) => {
    const {body, callback} = actions.payload;
    const makeSetOrders3PLReq = new Get3PLsRequestBuilder()
      .params(body)
      .data({})
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return {response, callback};
  };
  getOrder3PLs = async (actions: any) => {
    const {callback, ...actionsPayload} = actions.payload;
    const makeSetOrders3PLReq = new GetOrder3PLsRequestBuilder()
      .params(flattenObject({...actionsPayload}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return {response, callback};
  };
  getOrderTapin = async (actions: any) => {
    const {ids} = actions.payload;
    const makeSetOrders3PLReq = new GetOrderTapinsRequestBuilder()
      .id(ids)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return response;
  };
  getOrderTapinKetab = async (actions: any) => {
    const {ids} = actions.payload;
    const makeSetOrders3PLReq = new GetOrderTapinsKetabRequestBuilder()
      .id(ids)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return response;
  };

  getOrderTapinBarcode = async (actions: any) => {
    const {ids} = actions.payload;
    const makeSetOrders3PLReq = new GetOrderTapinsBarcodeRequestBuilder()
      .id(ids)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return response;
  };
  upload3PL = async (actions: any) => {
    const {body} = actions.payload;
    const makeRequest = new Upload3PLRequestBuilder().data(body).build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
  uploadMarketerFile = async (actions: any) => {
    const {body, params, type} = actions.payload;
    const makeRequest = new UploadOrdersRequestBuilder()
      .id(type)
      .params(params)
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
  getOrder3PL = async (actions: any) => {
    const {callback, id, ...actionsPayload} = actions.payload;
    const makeSetOrders3PLReq = new GetOrder3PLsRequestBuilder()
      .id(id)
      .params(flattenObject({...actionsPayload}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return {response, callback};
  };
  updateOrder3PL = async (actions: any) => {
    const {callback, body} = actions.payload;
    const makeSetOrders3PLReq = new UpdateOrder3PLsRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return {response, callback};
  };
  sendRequestOrder3PL = async (actions: any) => {
    const {callback, id} = actions.payload;
    const makeSetOrders3PLReq = new CreateRequestOrder3PLsRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeSetOrders3PLReq);
    return {response, callback};
  };
  cancel3PLItems = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateRequest = new Cancel3PLItemRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return {response, callback};
  };
  resendOrders = async (actions: any) => {
    const {body, callback} = actions.payload;
    const makeUpdateRequest = new ResendOrdersRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return {response, callback};
  };
  getSuggestedCourierAssignmentList = async (actions: any) => {
    const {body, params} = actions.payload;
    const makeUpdateRequest = new GetSuggestedCourierAssignmentList()
      .params(params)
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return response;
  };
  validateOrdersBeforeCreateTpl = async (actions: any) => {
    const {body} = actions.payload;
    const makeUpdateRequest = new ValidateOrdersBeforeCreateTpl()
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return response;
  };
  createBatchTpl = async (actions: any) => {
    const {body} = actions.payload;
    const makeUpdateRequest = new CreateBatchTpl().data(body).build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return response;
  };
}

export default new OrdersRepository();
